module.exports = "/images/bannerThree-mobile.jpg";